import styled from 'styled-components';
import { Collapse } from '@agendapro/emerald/v2';
import { applyEllipsisByNumOfLines } from '@/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  margin-top: ${({ theme }) => theme.spacing[8]};
  .styledCollapse:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.grays20};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing[16]};
`;

export const VideoConferenceContainer = styled.div`
  display: flex;
  align-items: center;
  i {
    margin-right: 4px;
    color: ${({ theme }) => theme.brandTheme.brand100};
  }
`;

export const CustomCollapse = styled(Collapse)`
  padding: ${({ theme }) => theme.spacing[16]};
`;

export const CollapseButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.spacing[16]};
  .serviceNumber {
    font-size: ${({ theme }) => theme.fontSize['xsmall-desktop']};
  }
  .serviceName {
    ${applyEllipsisByNumOfLines(1)};
  }
`;

export const CollapseContent = styled.div``;
